import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Swiper from '~/ui/components/common/Swiper/Swiper';

interface TestimonialSlide {
  id: number;
  title: string;
  description: string;
  stars: number;
}

const TestimonialsSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$testimonialsSection' });

  const testimonialSlides: TestimonialSlide[] = [
    { id: 1, title: t('firstSlideTitle'), description: t('firstSlideDescription'), stars: 5 },
    { id: 2, title: t('thirdSlideTitle'), description: t('thirdSlideDescription'), stars: 5 },
    { id: 3, title: t('fourthSlideTitle'), description: t('fourthSlideDescription'), stars: 5 },
    { id: 4, title: t('secondSlideTitle'), description: t('secondSlideDescription'), stars: 5 },
    { id: 5, title: t('fifthSlideTitle'), description: t('fifthSlideDescription'), stars: 5 },
    { id: 6, title: t('sixthSlideTitle'), description: t('sixthSlideDescription'), stars: 5 },
  ];

  const renderTestimonialSlide = (slide: TestimonialSlide): ReactElement => {
    const stars = [];
    for (let i = 0; i < slide.stars; i += 1) {
      stars.push(
        <div key={`${slide.id}-star-${i}`} className="star">
          ★
        </div>,
      );
    }

    return (
      <div className="swiper-slide" data-event-name="bloc_interact" data-bloc-name="testimonial">
        <div className="star-wrapper">
          {/* TODO: replace hearts with icons when new icons are ready */}
          {stars}
        </div>
        <h3>{slide.title}</h3>
        <p>{slide.description}</p>
      </div>
    );
  };

  return (
    <section id="hp-testimonials" className="hp-section light-gold testimonials">
      <h2 className="sr-only">{t('title')}</h2>
      <div className="carousel-wrapper">
        <div className="hp-swiper swiper slides-one loop">
          <Swiper
            slides={testimonialSlides}
            renderSlide={renderTestimonialSlide}
            slidesPerView={1}
            navigation // Include navigation
            pagination // Include pagination
            containerModifierClass="swiper-container-"
            className="swiper-container swiper-wrapper"
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
